export type FieldSort<action> = {
    field: string;
    action: action;
};
